/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Search, RotateCw } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import Select from 'react-select'
import { useDebounce } from 'use-debounce'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import TablePagination from '../../components/atoms/Table/TablePagination'
import Loader from '../../components/atoms/Loader'

const cardFilterStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  padding: '1.5rem',
  marginBottom: '1.5rem'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '45px',
    height: '45px',
    borderRadius: '10px',
    border: '1px solid #e9ecef',
    backgroundColor: '#ffffff',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    borderColor: state.isFocused ? '#f89d1d' : '#e9ecef',
    '&:hover': {
      borderColor: '#f89d1d'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#adb5bd',
    fontSize: '0.9rem'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.9rem',
    color: '#333'
  })
}

function StockInfoPacking() {
  const [filterWarehouse, setFilterWarehouse] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedQuery] = useDebounce(searchQuery, 1000)

  const [loading, setLoading] = useState(false)
  const [warehouses, setWarehouses] = useState([])
  const [data, setData] = useState({
    data: [],
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })

  useEffect(() => {
    fetchWarehouse()
  }, [])

  useEffect(() => {
    if (filterWarehouse || debouncedQuery) {
      if (data.metadata.current_page !== 1) {
        setData((prev) => ({
          ...prev,
          metadata: { ...prev.metadata, current_page: 1 }
        }))
      } else {
        fetchData()
      }
    } else {
      setData((prev) => ({
        ...prev,
        data: [],
        metadata: {
          ...prev.metadata,
          current_page: 1,
          total_row: 0,
          total_page: 0
        }
      }))
    }
  }, [filterWarehouse, debouncedQuery, data.metadata.per_page])

  useEffect(() => {
    if (filterWarehouse || debouncedQuery) {
      fetchData()
    }
  }, [data.metadata.current_page])

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: 1,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      setWarehouses(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true)
      const params = {
        per_page: data.metadata.per_page,
        page: data.metadata.current_page,
        warehouse_id: filterWarehouse ? filterWarehouse.value : null,
        q: debouncedQuery
      }
      const res = await api.get('master/stocks/packing', {
        params
      })
      const { data: dataResponse } = res
      if (dataResponse.success) {
        setData({
          data: dataResponse.data,
          metadata: dataResponse.metadata
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      setData({
        data: [],
        metadata: {
          per_page: 10,
          current_page: 1,
          total_row: 0,
          total_page: 0
        }
      })
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      key: 'item_name',
      label: 'Item Name'
    },
    {
      key: 'item_code',
      label: 'Item Code'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      component: (dataColumn) => `${dataColumn.total_pack} ${dataColumn.uom}`,
      className: 'text-end'
    }
  ]

  const handlePageChange = (val) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: val.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        per_page: parseInt(e.target.value, 10),
        current_page: 1
      }
    }))
  }

  const resetFilter = () => {
    setFilterWarehouse(null)
    setSearchQuery('')
    setData((prev) => ({
      ...prev,
      data: [],
      metadata: {
        ...prev.metadata,
        current_page: 1,
        total_row: 0,
        total_page: 0
      }
    }))
  }

  return (
    <>
      <Toaster />
      <div className="container-fluid px-4 mb-5">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 className="header-title-style">Stock Info Packing</h3>
          </Col>
          <Col className="text-end">
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={resetFilter}
              style={{ fontSize: '0.85rem' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="gy-3">
            <Col md={6}>
              <Form.Label style={labelStyle}>WAREHOUSE NAME</Form.Label>
              <Select
                isClearable
                value={filterWarehouse}
                onChange={(option) => {
                  setFilterWarehouse(option)
                }}
                options={warehouses.map((w) => ({
                  value: w.id,
                  label: w.warehouse_name
                }))}
                placeholder="Select Warehouse"
                isSearchable
                styles={customStyles}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={labelStyle}>Search Item Name</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Item Name..."
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card>

        <Row>
          <Col md={12}>
            <Table
              responsive
              hover
              className="shadow-sm bg-white"
              style={{
                fontSize: '0.9rem',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columns.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className || ''}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={columns.length} className="p-5 text-center">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading && data?.data?.length === 0 && (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="p-5 text-center text-muted fw-bold"
                    >
                      No data
                    </td>
                  </tr>
                )}
                {!loading &&
                  data?.data?.map((stock, index) => (
                    <tr
                      key={index}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      {columns.map((column) => (
                        <td
                          key={column.key}
                          className={`align-middle p-2 ${column.className || ''}`}
                        >
                          {column.component && column.component(stock)}
                          {!column.component && stock[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={columns.length}>
                    <TablePagination
                      meta={data?.metadata}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </div>
    </>
  )
}
export default StockInfoPacking
